module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Add-music-9c3c39849341b33c57c66aed974c5961.svg";